import {InviteI18n} from '@/locales/base.message.locales';

export const invites: InviteI18n = {
  title: 'Convites pendente',
  labels: {
    accepted: 'Aceito',
    pendent: 'Pendente',
    refused: 'Recusado',
  },
  messages: {
    accepted: {
      failed: 'Falhou ao aceitar o convite',
      success: 'Convite aceito com sucesso',
    },
    refused: {
      failed: 'Falhou ao recusar o convite',
      success: 'Convite recusado com sucesso',
    },
    canceled: {
      failed: 'Falhou ao cancelar o convite',
      success: 'Convite cancelado com sucesso',
    },
    send: {
      failed: 'Falhou ao enviar o convite',
      success: 'Convite enviado com sucesso',
    },
  },
  buttons: {
    accept: 'Aceitar',
    refuse: 'Recusar',
    cancel_invite: 'Cancelar convite',
    accept_invite: 'Aceitar convite'
  }
};
